var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetterThanReviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 202.42 102.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.18;}.cls-2{fill:url(#linear-gradient-4);stroke:url(#linear-gradient-5);}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-width:2px;}.cls-2,.cls-3,.cls-4,.cls-6,.cls-9,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-2,.cls-9,.cls-8{fill-opacity:.5;}.cls-10{fill:url(#linear-gradient-14);}.cls-10,.cls-5,.cls-11,.cls-12,.cls-13{stroke-linecap:round;stroke-linejoin:round;}.cls-10,.cls-11,.cls-12,.cls-13{stroke:#fff;}.cls-3{fill:none;stroke:url(#linear-gradient-3);}.cls-4{stroke:url(#linear-gradient-8);}.cls-4,.cls-6,.cls-7{fill:#fff;}.cls-5{fill:rgba(255,255,255,.75);stroke:#7da2fe;}.cls-11{fill:url(#linear-gradient-13);}.cls-6{stroke:url(#linear-gradient-10);}.cls-9{fill:url(#linear-gradient-6);stroke:url(#linear-gradient-7);stroke-width:7px;}.cls-14{fill:#020004;}.cls-12{fill:url(#linear-gradient-12);}.cls-7{stroke:url(#linear-gradient-9);}.cls-8{fill:url(#linear-gradient);stroke:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-11);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 138.88,
    y1: 19.89,
    x2: 152.08,
    y2: 19.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 137.88,
    x2: 153.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 144.48,
    y1: 12.76,
    x2: 146.48,
    y2: 12.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 141.41,
    y1: 5.08,
    x2: 149.56,
    y2: 5.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 140.41,
    y1: 5.08,
    x2: 150.56,
    y2: 5.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 92.05,
    y1: 62.89,
    x2: 198.92,
    y2: 62.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 88.55,
    y1: 62.89,
    x2: 202.42,
    y2: 62.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 114.14,
    y1: 53.65,
    x2: 132.84,
    y2: 53.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 158.13,
    y1: 53.65,
    x2: 176.82,
    y2: 53.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 114.14,
    y1: 77.17,
    x2: 176.82,
    y2: 77.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -7355.38,
    y1: 26.19,
    x2: -7337.18,
    y2: 26.19,
    gradientTransform: "translate(-7257.72) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -7333.49,
    y1: 26.19,
    x2: -7315.28,
    y2: 26.19,
    gradientTransform: "translate(-7257.72) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -7311.59,
    y1: 26.19,
    x2: -7293.39,
    y2: 26.19,
    gradientTransform: "translate(-7257.72) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -7289.7,
    y1: 26.19,
    x2: -7271.49,
    y2: 26.19,
    gradientTransform: "translate(-7257.72) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.08,23.19h-13.2c0-3.32,2.5-6.09,5.7-6.54,.3-.04,.6-.06,.9-.06s.61,.02,.9,.06c3.2,.45,5.7,3.22,5.7,6.54Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 145.48,
    y1: 16.37,
    x2: 145.48,
    y2: 9.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 145.48,
    cy: 5.08,
    r: 4.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 92.05,
    y: 26.5,
    width: 106.87,
    height: 72.78,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.49,
    cy: 53.65,
    r: 8.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 167.47,
    cy: 53.65,
    r: 8.35
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.14,68.68h60.68c0,9.37-7.61,16.98-16.98,16.98h-26.72c-9.37,0-16.98-7.61-16.98-16.98h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M6,20.17v21.64c0,5.71,4.67,10.39,10.39,10.39H105.05l8.93,7.5c.58,.48,1.46,.07,1.46-.68V20.17c0-5.71-4.67-10.39-10.39-10.39H16.38c-5.71,0-10.39,4.67-10.39,10.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1,15.37v21.64c0,5.71,4.67,10.39,10.39,10.39H100.05l10.39,8.72V15.37c0-5.71-4.67-10.39-10.39-10.39H11.39C5.67,4.98,1,9.66,1,15.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "88.56 17.53 85.75 23.23 79.46 24.14 84.01 28.58 82.94 34.84 88.56 31.88 94.19 34.84 93.11 28.58 97.66 24.14 91.38 23.23 88.56 17.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "66.67 17.53 63.86 23.23 57.57 24.14 62.12 28.58 61.04 34.84 66.67 31.88 72.29 34.84 71.22 28.58 75.77 24.14 69.48 23.23 66.67 17.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "44.77 17.53 41.96 23.23 35.67 24.14 40.22 28.58 39.15 34.84 44.77 31.88 50.4 34.84 49.32 28.58 53.87 24.14 47.59 23.23 44.77 17.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "22.88 17.53 20.07 23.23 13.78 24.14 18.33 28.58 17.25 34.84 22.88 31.88 28.5 34.84 27.43 28.58 31.98 24.14 25.69 23.23 22.88 17.53"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterThanReviews);
export default __webpack_public_path__ + "static/media/betterThanReviews.89fdc904c0022dd164e49e942af74b56.svg";
export { ForwardRef as ReactComponent };